/* eslint-disable no-bitwise, no-loops/no-loops, max-lines, max-statements, no-restricted-syntax, no-prototype-builtins */
import { closest, getOffsetRect, getTotalScroll, getTransformProps } from '@elliemae/ds-shared';

export function onDragStart(e, item) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  this.el = closest(e.target, '.nestable-item');
  this.startTrackMouse();
  this.onMouseMove(e);
  const { items } = this.state;
  this.setState({
    dragItem: item,
    itemsOld: items,
  });
}

export function onDragEnd(e, isCancel) {
  if (e && e.preventDefault) e.preventDefault();

  this.stopTrackMouse();
  this.el = null;

  // check if filter has children
  const { items } = this.state;
  const nestedInFilter = this.checkFilterChildren(items);
  if (nestedInFilter) return this.dragRevert();

  return isCancel ? this.dragRevert() : this.dragApply();
}

export function onMouseMove(e) {
  const { group, threshold } = this.props;
  const { dragItem } = this.state;
  const { clientX, clientY } = e;
  const transformProps = getTransformProps(clientX, clientY);
  const elCopy = document.querySelector(`.nestable-${group} .nestable-drag-layer > .nestable-list`);
  if (!this.elCopyStyles) {
    const offset = getOffsetRect(this.el);
    const scroll = getTotalScroll(this.el);

    this.elCopyStyles = {
      marginTop: offset.top - clientY - scroll.top,
      marginLeft: offset.left - clientX - scroll.left,
      ...transformProps,
    };
  } else {
    this.elCopyStyles = {
      ...this.elCopyStyles,
      ...transformProps,
    };
    for (const key in transformProps) {
      if (transformProps.hasOwnProperty(key)) {
        elCopy.style[key] = transformProps[key];
      }
    }
    const diffX = clientX - this.mouse.last.x;
    if ((diffX >= 0 && this.mouse.shift.x >= 0) || (diffX <= 0 && this.mouse.shift.x <= 0)) {
      this.mouse.shift.x += diffX;
    } else {
      this.mouse.shift.x = 0;
    }
    this.mouse.last.x = clientX;
    if (Math.abs(this.mouse.shift.x) > threshold) {
      if (this.mouse.shift.x > 0) {
        this.tryIncreaseDepth(dragItem);
      } else {
        this.tryDecreaseDepth(dragItem);
      }
      this.mouse.shift.x = 0;
    }
  }
}
export function onMouseEnter(e, item) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const { collapsed, childrenProp } = this.props;
  const { dragItem } = this.state;
  if (dragItem.id === item.id) return;

  const pathFrom = this.getPathById(dragItem.id);
  const pathTo = this.getPathById(item.id);

  // if collapsed by default
  // and move last (by count) child
  // remove parent node from list of open nodes
  let collapseProps = {};
  if (collapsed && pathFrom.length > 1) {
    const parent = this.getItemByPath(pathFrom.slice(0, -1));
    if (parent[childrenProp].length === 1) {
      collapseProps = this.onToggleCollapse(parent, true);
    }
  }

  this.moveItem({ dragItem, pathFrom, pathTo }, collapseProps);
}

export function onToggleCollapse(item, isGetter) {
  const { collapsed } = this.props;
  const { collapsedGroups } = this.state;
  const isCollapsed = this.isCollapsed(item);

  const newState = {
    collapsedGroups:
      isCollapsed ^ collapsed ? collapsedGroups.filter((id) => id !== item.id) : collapsedGroups.concat(item.id),
  };

  if (isGetter) {
    return newState;
  }
  return this.setState(newState);
}
export function onKeyDown(e) {
  if (e.which === 27) {
    // ESC
    this.onDragEnd(null, true);
  }
}
